"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ServiceCenter_1 = __importDefault(require("./ServiceCenter/ServiceCenter"));
var Queries_1 = require("../Graphql/Queries");
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var client_1 = require("@apollo/client");
var HeaderBar_1 = __importDefault(require("../../../../theme/headerbar/HeaderBar"));
var react_i18next_1 = require("react-i18next");
var Mutation_1 = require("../Graphql/Mutation");
var ServiceMain = function () {
    var organization = (0, org_hook_1.useOrg)().organization;
    var t = (0, react_i18next_1.useTranslation)().t, _a = (0, react_1.useState)(null), success = _a[0], setSuccess = _a[1], _b = (0, react_1.useState)(false), loadings = _b[0], setLoading = _b[1], _c = (0, react_1.useState)([]), centers = _c[0], setCenters = _c[1];
    (0, react_1.useEffect)(function () {
        init(organization);
    }, [organization]);
    var init = function (organization) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!organization) return [3 /*break*/, 2];
                    setLoading(true);
                    return [4 /*yield*/, callServiceCenterList()];
                case 1:
                    data = (_a.sent()).data;
                    setCenters(data.getAllServiceCenterByOrganization);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var callServiceCenterList = (0, client_1.useLazyQuery)(Queries_1.GET_SERVICE_CENTER_BY_ORGANIZATION, {
        variables: { organization_id: organization.id },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
        onCompleted: function () {
            setLoading(false);
        },
        onError: function () {
            setLoading(false);
        },
    })[0];
    var _d = (0, client_1.useMutation)(Mutation_1.UPSERT_SERVICE_CATEGORY, {
        fetchPolicy: "no-cache",
        refetchQueries: ["getAllServiceCategoriesByOrganization"],
        onCompleted: function (res) {
            setLoading(false);
            setSuccess(res.data.bulkUpsertServiceCategory);
        },
        onError: function () {
            setLoading(false);
        },
    }), callUpsertCategory = _d[0], responseUpsertCategory = _d[1];
    var _e = (0, client_1.useLazyQuery)(Queries_1.GET_SERVICE_CATEGORY, {
        variables: { organization_id: organization.id },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
        onCompleted: function () {
            setLoading(false);
        },
        onError: function () {
            setLoading(false);
        },
    }), callServiceCategoryList = _e[0], catData = _e[1].data;
    var onCatSave = function (catData) {
        window.scrollTo(0, 0);
        setLoading(true);
        var variables = { input: catData };
        callUpsertCategory({
            variables: variables,
        });
    };
    (0, react_1.useEffect)(function () {
        if (organization) {
            setLoading(true);
            callServiceCategoryList();
        }
    }, [organization]);
    return (react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column", flex: 1 } },
        react_1.default.createElement(HeaderBar_1.default, { title: "services", hideSave: true },
            react_1.default.createElement(ServiceCenter_1.default, { data: centers, setCenters: setCenters }))));
};
exports.default = ServiceMain;
